export default "__VITE_ASSET__C_EhVA1y__"